import RouteNav from './RouteNav';
import { useAppEntryDataFetching } from './hooks/useAppEntryDataFetching';

export default function AppRoutes() {
  const { loading } = useAppEntryDataFetching();

  return <RouteNav loading={loading} />;
}
